import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { VideoTutorialService } from '../services/video-tutorial.service';

export const videoTutorialsLoadedGuard: CanActivateFn = (): boolean => {
  const videoTutorialService = inject(VideoTutorialService);
  if (
    !videoTutorialService.value() &&
    !videoTutorialService.isLoading() &&
    !videoTutorialService.error()
  ) {
    videoTutorialService.load(); // fire & forget
  }
  return true;
};
